import allClassJobs from "./data/classJobNames.json";

export function updateJobText(context = document) {
  const elements = Array.from(context.getElementsByClassName("joblvl"));
  const jobs = Alpine.store('characterData').jobs();
  if (jobs === undefined || jobs === {}) {
    return;
  }

  elements.forEach((element) => {
    const splitElementId = element.id.split("-")
    const jobNameShort = splitElementId[0];
    const levelOfDetails = splitElementId[1];
    const jobDetails = jobs[jobNameShort];

    if (jobDetails == undefined)
      return;

    switch(levelOfDetails) {
      case "lvl1": {
        element.innerHTML = jobDetails.level;
        break;
      };
      case "lvl2": {
        element.innerHTML = `${jobDetails.name}<br>Level ${jobDetails.level}`;
        break;
      };
      case "lvl3": {
        element.innerHTML = `${jobDetails.abbrev.toUpperCase()} ${jobDetails.level}`;
        break;
      };
    };
  });
};

export function jobsByRole(role) {
  return Object.entries(allClassJobs).filter(([_, job]) => job.role === role).map(([_, job]) => job);
};

export function findJobByName(jobName) {
  return Object.entries(allClassJobs).find(([_, job]) => job.jobName === jobName)[1];
};

